export default __webpack_public_path__ + "static/media/map.9da25ad2.webp";